import ReconnectingWebSocket from 'reconnecting-websocket';

export const websocket = new ReconnectingWebSocket(`${process.env.REACT_APP_WS_URL}`);
